import { FC, InputHTMLAttributes, MouseEvent, ReactNode } from 'react';
import classNames from '../../utils/classnames';
import { CatalogProps } from '../../utils/enhanced-ecommerce';
import { handleMouseDown } from '../../utils/material/material-helper';
import './material-click-handler.scss';

const MIDDLE_BUTTON = 1;

type MaterialClickHandlerProps = InputHTMLAttributes<HTMLSpanElement> & {
    children: ReactNode;
    item: Material;
    materialProps: CatalogProps;
    searchRequestId?: string;
    transparent?: boolean;
};

const MaterialClickHandler: FC<MaterialClickHandlerProps> = ({ children, ...props }) => {
    const { item, materialProps, className, searchRequestId, transparent } = props;

    const handleTrack = () => handleMouseDown({ material: item, props: materialProps, searchRequestId });
    const handleAuxClick = (event: MouseEvent<HTMLSpanElement>) => {
        if (event.button === MIDDLE_BUTTON) {
            handleTrack();
        }
    };

    return (
        <span
            className={classNames('click-handler', className, { 'click-handler--transparent': transparent })}
            onClickCapture={handleTrack}
            onAuxClick={handleAuxClick}
        >
            {children}
        </span>
    );
};

export default MaterialClickHandler;
